// GENERATED by store-ksp from @StoreProvider. DO NOT EDIT — this is a build
// artifact, not committed source. Change the annotation on the provider instead.

package kpt.core.store.config

/**
 * Stream cache keys — the strings that key per-stream freshness tracking, grouped by store.
 *
 * A repository references `AppCacheKeys.Loans.LIST` or `AppCacheKeys.Loans.item(id)` and never
 * spells the format at the call site. Derived from `@CacheKey`.
 */
object AppCacheKeys {
    object Alerts {
        const val LIST = "alerts"
    }

    object AmortizationCalc {
        fun of(principal: Double, ratePercent: Double, tenureMonths: Int): String = "amortizationCalc:$principal:$ratePercent:$tenureMonths"
    }

    object BillReminders {
        const val LIST = "billReminders"
        fun item(id: String): String = "billReminder:$id"
    }

    object CloudTodo {
        fun item(id: Int): String = "cloudTodo:$id"
    }

    object CoinDetail {
        fun item(coinId: String): String = "crypto:coinDetail:$coinId"
    }

    object CoinMarkets {
        const val LIST = "crypto:coinMarkets"
    }

    object Emi {
        fun of(principal: Double, ratePercent: Double, tenureMonths: Int): String = "emi:$principal:$ratePercent:$tenureMonths"
    }

    object ExchangeRates {
        fun of(baseCurrency: String): String = "currency:exchangeRates:$baseCurrency"
    }

    object InterestRateSeries {
        fun of(seriesId: String, days: Int): String = "economic:rates:$seriesId:${days}d"
    }

    object Loans {
        const val LIST = "loans"
        fun item(id: String): String = "loan:$id"
    }

    object MacroIndicator {
        fun of(countryCode: String, indicator: String, years: Int): String = "economic:macro:$countryCode:$indicator:${years}y"
    }

    object Profile {
        const val KEY = "profile"
    }

    object RateHistory {
        fun of(from: String, to: String, days: Int): String = "currency:rateHistory:$from-$to-${days}d"
    }

    object SpotRate {
        fun of(baseCurrency: String): String = "currency:spotRate:$baseCurrency"
    }

    object UserData {
        const val KEY = "userData"
    }

    object Watchlist {
        const val LIST = "watchlist"
    }
}
